export function ProjectsPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-8">
        プロジェクト管理
      </h1>
      <div className="card">
        <p className="text-gray-600">
          プロジェクト管理機能は現在開発中です。
        </p>
      </div>
    </div>
  )
}